import type { LocationQuery } from "vue-router";

/** Branding code used instead of `theme=verivox` (Verivox-specific theme CSS is deprecated). */
export const VERIVOX_THEME_BRANDING_CODE = "85611BA8";

/**
 * Detects `theme=verivox` in the route query (string or array).
 */
export function routeQueryHasVerivoxTheme(query: LocationQuery): boolean {
  const raw = query.theme;
  if (raw === undefined || raw === null) return false;
  const s = Array.isArray(raw) ? raw[0] : raw;
  return String(s).toLowerCase() === "verivox";
}

/**
 * Replaces Verivox theme with default theme + canonical branding code.
 * Call from a router guard with `replace: true` so bookmarks update.
 */
export function replaceVerivoxThemeQuery(query: LocationQuery): LocationQuery {
  const next: LocationQuery = { ...query };
  next.code = VERIVOX_THEME_BRANDING_CODE;
  next.theme = "covomo";
  return next;
}
